const patchRoot = require('./patchRoot');
const root = require("./gen/proto-bundle.js");

patchRoot(root);

class DaqGatewayClient {
    constructor(brokerRpc) {
        this.root = root;
        this.gateway = root.gateway.core.Gateway.create(
            brokerRpc.rpc('gateway.core.Gateway'), false, false);
        this.modules = root.gateway.core.Modules.create(
            brokerRpc.rpc('gateway.core.Modules'), false, false);
        this.daqs = root.gateway.core.Daqs.create(
            brokerRpc.rpc('gateway.core.Daqs'), false, false);
        this.sensors = root.gateway.core.Sensors.create(
            brokerRpc.rpc('gateway.core.Sensors'), false, false);
    }
}

module.exports = DaqGatewayClient;